import { Navigate, useLocation } from "react-router";
import type { CustomerAppConfigAuthError } from "undercarriage";

const getAuthErrorPath = (authError: CustomerAppConfigAuthError): string => {
  switch (authError.typ) {
    case "email_login_constraint":
      return `/authn-wf/email-constraint?to=${authError.shouldLoginAs}`;
    case "user_deactivated":
      return "/authn-wf/account-deactivated";
    default:
      authError satisfies never;
      return "/authn-wf/error";
  }
};

export const AppConfigAuthRedirect = ({
  authError,
  children,
}: {
  authError: CustomerAppConfigAuthError | undefined;
  children: React.ReactNode;
}) => {
  const location = useLocation();
  const authErrorPath = authError ? getAuthErrorPath(authError) : null;
  if (authErrorPath && authErrorPath !== location.pathname + location.search) {
    return <Navigate replace to={authErrorPath} />;
  }
  return children;
};
